import { BlobFilesClient } from "./blobFilesClient";

export const blobFilesClientStub: BlobFilesClient = {
  createNewBlob: async () => {
    return {
      createUrl: "some-create-url",
      token: "some-token",
    };
  },
};
